import { Pipe, PipeTransform } from "@angular/core";
import { AddressPipeService } from "./address-pipe.service";
import { map } from "rxjs/operators";

@Pipe({
  name: "province"
})
export class ProvincePipe implements PipeTransform {
  constructor(
    private addressPipeService: AddressPipeService
  ) { }

  // HOW TO USE
  // <p>{{ 'TH' | province|async }}</p> => no lang
  // <p>{{ 'TH' | province:'EN'|async }}</p> => Add lang

  transform(value: any, lang?: any): any {
    if (!lang) {
      lang = "TH";
    }

    return this.addressPipeService.getProvinceByCode(value, lang)
    .pipe(
      map(res => {
        if (res === "-") {

          return value;
        } else {

          return res;
        }
      })
    );

  }

}
